import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#54208f] text-white">
      <div className="mx-auto max-w-7xl px-6 py-10">
        <div className="grid gap-10 md:grid-cols-[1.2fr_0.9fr_0.9fr]">
          {/* Left: Logo + Description */}
          <div>
            <Link to="/" className="inline-block" aria-label="ACDC home">
              <div className="flex h-20 w-20 items-center justify-center rounded-xl bg-white md:h-24 md:w-24">
                <img
                  src="/assets/images/acdc-logo.svg"
                  onError={(e) => { e.currentTarget.src = '/assets/images/acdc-logo-backup.png'; }}
                  alt="ACDC Logo"
                  className="h-16 w-16 object-contain md:h-20 md:w-20"
                />
              </div>
            </Link>
            <p className="mt-5 text-sm leading-6 text-white/90">
              Asian Community Development Center (ACDC) is a DBA of Asian
              Pacific and Korean Business Organization Inc., a federally
              recognized 501(c)(3) nonprofit organization (EIN: 92-3144739).
              All contributions are tax-deductible to the extent permitted by
              law.
            </p>
          </div>

          {/* Middle: Quick Links — H3 */}
          <div>
            <h3 className="text-xs font-semibold tracking-[0.22em]">QUICK LINKS</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="hover:text-white/80" to="/about">About Us</Link></li>
              <li><Link className="hover:text-white/80" to="/services">Business Services</Link></li>
              <li><Link className="hover:text-white/80" to="/education">Education Services</Link></li>
              <li><Link className="hover:text-white/80" to="/events">Events</Link></li>
              <li><Link className="hover:text-white/80" to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Right: Contact + Social — H3 */}
          <div>
            <h3 className="text-xs font-semibold tracking-[0.22em]">CONTACT</h3>
            <div className="mt-4 space-y-2 text-sm">
              <div>2222 South Fraser Street Unit 2</div>
              <div>Aurora, CO 80014</div>
              <div>
                <a href="mailto:info@acdcco.org" className="hover:text-white/80">info@acdcco.org</a>
              </div>
            </div>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href="https://www.instagram.com/acdcco_org/"
                target="_blank"
                rel="noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-white/50 hover:bg-white/10"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="white" strokeWidth="1.8">
                  <rect x="4" y="4" width="16" height="16" rx="4"></rect>
                  <circle cx="12" cy="12" r="3.2"></circle>
                  <circle cx="17.2" cy="6.8" r="1"></circle>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/acdcco/"
                target="_blank"
                rel="noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-white/50 hover:bg-white/10"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="white">
                  <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6C1.12 6 0 4.88 0 3.5C0 2.12 1.12 1 2.5 1C3.88 1 4.98 2.12 4.98 3.5ZM0.5 22H4.5V7H0.5V22ZM8 7H12V9.17C12.58 8.17 13.97 6.9 16.1 6.9C20.16 6.9 21 9.35 21 13.2V22H17V14.2C17 12.3 16.96 9.9 14.3 9.9C11.6 9.9 11.2 12 11.2 14.06V22H7.2V7H8Z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/AsianCommunityDevelopmentCenter/"
                target="_blank"
                rel="noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-white/50 hover:bg-white/10"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="white">
                  <path d="M13 9H16V6H13C10.8 6 9 7.8 9 10V12H7V15H9V22H12V15H15L16 12H12V10C12 9.45 12.45 9 13 9Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@AsianCommunityDevelopmentCente"
                target="_blank"
                rel="noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-white/50 hover:bg-white/10"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="white">
                  <path d="M21.8 8.2a2.8 2.8 0 0 0-2-2C18.1 5.7 12 5.7 12 5.7s-6.1 0-7.8.5a2.8 2.8 0 0 0-2 2A29 29 0 0 0 1.7 12a29 29 0 0 0 .5 3.8 2.8 2.8 0 0 0 2 2c1.7.5 7.8.5 7.8.5s6.1 0 7.8-.5a2.8 2.8 0 0 0 2-2 29 29 0 0 0 .5-3.8 29 29 0 0 0-.5-3.8ZM10 15.5v-7l6 3.5-6 3.5Z" />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@acdcco"
                target="_blank"
                rel="noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-white/50 hover:bg-white/10"
                aria-label="TikTok"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="white">
                  <path d="M14.8 3c.3 1.9 1.5 3.5 3.2 4.3.7.3 1.4.5 2.1.5V11a7.4 7.4 0 0 1-5.3-2.2v6.1a5.9 5.9 0 1 1-5.9-5.9c.4 0 .8 0 1.2.1v3.3a2.6 2.6 0 1 0 1.4 2.3V3h3.3Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-white/20 pt-6 text-center text-xs text-white/80">
          © Asian Community Development Center 2026
        </div>
      </div>
    </footer>
  );
};

export default Footer;
